import './MetricsCard.css';

interface MetricsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: string;
  trend?: {
    value: number;
    label: string;
  };
  color?: 'default' | 'green' | 'blue' | 'orange' | 'red';
}

export const MetricsCard = ({
  title,
  value,
  subtitle,
  icon,
  trend,
  color = 'default',
}: MetricsCardProps) => {
  return (
    <div className={`metrics-card metrics-card-${color}`}>
      {icon && <div className="metrics-card-icon">{icon}</div>}
      
      <div className="metrics-card-content">
        <h3 className="metrics-card-title">{title}</h3>
        <div className="metrics-card-value">{value}</div>
        
        {subtitle && (
          <p className="metrics-card-subtitle">{subtitle}</p>
        )}
        
        {trend && (
          <div className={`metrics-card-trend trend-${trend.value >= 0 ? 'positive' : 'negative'}`}>
            <span className="trend-arrow">{trend.value >= 0 ? '↑' : '↓'}</span>
            <span className="trend-value">{Math.abs(trend.value)}</span>
            <span className="trend-label">{trend.label}</span>
          </div>
        )}
      </div>
    </div>
  );
};

